import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const Button = styled.a`
  display: flex;
  width: 100%;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.06);
  color: ${({ theme }) => theme.text_primary};
  font-size: 14px;
  font-weight: 700;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  cursor: pointer;
  text-decoration: none;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition:
    transform 0.18s ease,
    background 0.18s ease,
    border-color 0.18s ease;
  &:hover {
    transform: translateY(-1px);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
  }
`;
const Card = styled(motion.div)`
  width: 330px;
  height: 490px;
  background: rgba(15, 23, 42, 0.72);
  cursor: pointer;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.38);
  backdrop-filter: blur(10px);
  overflow: hidden;
  padding: 26px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition:
    transform 0.22s ease,
    box-shadow 0.22s ease,
    border-color 0.22s ease;
  &:hover {
    border-color: rgba(0, 174, 239, 0.35);
    box-shadow: 0 26px 90px rgba(0, 0, 0, 0.55);
  }
`;

const Image = styled.img`
  width: 100%;
  height: 180px;
  background-color: rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const Tags = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;

const Tag = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.primary};
  background-color: rgba(0, 174, 239, 0.14);
  padding: 2px 8px;
  border-radius: 10px;
`;

const Details = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding: 0px 2px;
`;
const Titles = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  overflow: hidden;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Date = styled.div`
  font-size: 12px;
  margin-left: 2px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_secondary + 80};
  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

const Description = styled.div`
  font-weight: 400;
  color: ${({ theme }) => theme.text_secondary};
  overflow: hidden;
  margin-top: 8px;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;

// const Members = styled.div`
//     display: flex;
//     align-items: center;
//     padding-left: 10px;
// `
// const Avatar = styled.img`
//     width: 38px;
//     height: 38px;
//     border-radius: 50%;
//     margin-left: -10px;
//     background-color: ${({ theme }) => theme.white};
//     box-shadow: 0 0 10px rgba(0,0,0,0.2);
//     border: 3px solid ${({ theme }) => theme.card};
// `

const ProjectCards = ({ project, setOpenModal }) => {
  const handleOpen = () => {
    if (typeof setOpenModal === "function") {
      setOpenModal({ state: true, project: project });
      return;
    }
    if (project?.github) {
      window.open(project.github, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Card
      onClick={handleOpen}
      whileHover={{ y: -10 }}
      transition={{ duration: 0.22 }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleOpen();
      }}
    >
      <Image src={project.image} alt={project.title} />
      <Tags>
        {project.tags?.map((tag, index) => (
          <Tag key={`${project.id ?? project.title}-tag-${index}`}>{tag}</Tag>
        ))}
      </Tags>
      <Details>
        <Titles>{project.title}</Titles>
        <Date>{project.date}</Date>
        <Description>{project.description}</Description>
      </Details>
      {/* <Members>
                {project.member?.map((member) => (
                    <Avatar src={member.img}/>
                ))}
            </Members> */}
      {project?.github ? (
        <Button
          href={project.github}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          View Project
        </Button>
      ) : null}
    </Card>
  );
};

export default ProjectCards;
